// extracted by mini-css-extract-plugin
var _1 = "AltLoginsForm-module__apple___mUI7L";
var _2 = "AltLoginsForm-module__content___W3Ual";
var _3 = "AltLoginsForm-module__google___K1MeV";
var _4 = "AltLoginsForm-module__text___bkNLy";
export { _1 as "apple", _2 as "content", _3 as "google", _4 as "text" }
